import { useLocation } from 'react-router-dom'

export const useUrlAuth = () => {
  let { hash } = useLocation()

  // Remove '#'
  hash = hash.slice(1)
  const params = hash.split('&')

  const urlAuth = new Map()

  params.forEach((param) => {
    const [key, value] = param.split('=')
    urlAuth.set(key, value)
  })

  return { urlAuth }
}
